<template>
	<div class="home">
		<div class="message">配送地址</div>
		<w-amap @onInitMap="initMap"></w-amap>
		<div class="btn-bar">
			<el-button type="primary" @click="createPolygon">绘制多边形</el-button>
			<el-button type="primary" @click="clearPolygon">清除多边形</el-button>
			<el-button type="primary" @click="createPointMarket">添加客户地址</el-button>
			<el-button type="primary" @click="isPointInRing">可送范围</el-button>
			<el-button type="primary" @click="computedDriving">计算配送路线</el-button>
			<el-button type="primary" @click="clearDriving">清除配送路线</el-button>
		</div>
		<div class="btn-search">
			<span>请输入关键字</span>
			<input type="text" id="searchInput">
		</div>
	</div>
</template>

<script>
let _AMap = null
export default {
	name: 'home',
	data () {
		return {
			mapObj: null,
			mapMakers: [],
			polygon: null,
			pointMarker: null,
			autoInput: null,
			drive: null
		}
	},
	methods: {
		initMap ([amapObj, AMap]) {
			_AMap = AMap
			this.mapObj = amapObj
			// _AMap.plugin(['AMap.Autocomplete', 'AMap.Driving'], (res) => {
			// 	this.initSearchInput()
			// 	this.initDrive()
			// })
			this.initSearchInput()
			this.initDrive()
			this.createGeolocation()
			this.bindMapClick()
		},
		createGeolocation () {
			this.mapObj.plugin('AMap.Geolocation', () => {
				let geolocation = new _AMap.Geolocation({
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 0,
					convert: true,
					showButton: true,
					buttonPosition: 'LB',
					buttonOffset: new _AMap.Pixel(10, 20),
					showMarker: true,
					showCircle: true,
					panToLocation: true,
					zoomToAccuracy: true
				})
				let onComplete = (res) => {
					console.log(res)
				}
				let onError = (error) => {
					console.log(error)
				}
				this.mapObj.addControl(geolocation)
				geolocation.getCurrentPosition()
				_AMap.event.addListener(geolocation, 'complete', onComplete)
				_AMap.event.addListener(geolocation, 'error', onError)
			})
		},
		bindMapClick () {
			this.mapObj.on('click', (ev) => {
				console.log(ev)
				var marker = new _AMap.Marker({
					position: new _AMap.LngLat(ev.lnglat.lng, ev.lnglat.lat),
					title: '标记',
					draggable: false
				})
				marker.on('rightclick', (ev) => {
					this.mapObj.remove(marker)
				})
				this.mapObj.add(marker)
				this.mapMakers.push(marker)
			})
		},
		createPolygon () {
			var pathArr = this.mapMakers.map(item => {
				return item.getPosition()
			})
			console.log(pathArr)
			this.polygon = new _AMap.Polygon({
				path: pathArr,
				strokeColor: '#FF33FF',
				strokeWeight: 6,
				strokeOpacity: 0.2,
				fillOpacity: 0.4,
				fillColor: '#1791fc',
				zIndex: 50
			})
			this.clearPolygon()
			this.mapObj.add(this.polygon)
		},
		clearPolygon () {
			this.mapObj.remove(this.mapObj.getAllOverlays('polygon'))
		},
		createPointMarket () {
			if (this.pointMarker) {
				this.mapObj.remove(this.pointMarker)
			}
			this.pointMarker = new _AMap.Marker({
				position: new _AMap.LngLat(117.123037, 39.090791),
				icon: require('$assets/images/icon/icon-location-red.png'),
				title: '客户地址',
				draggable: true
			})
			this.pointMarker.on('rightclick', (ev) => {
				this.mapObj.remove(this.pointMarker)
			})
			this.mapObj.add(this.pointMarker)
		},
		isPointInRing () {
			var userLocation = this.pointMarker.getPosition()
			var pathArr = this.mapMakers.map(item => {
				return item.getPosition()
			})
			var inRing = _AMap.GeometryUtil.isPointInRing(userLocation, pathArr)
			if (inRing) {
				this.$message({
					message: '在可配送范围内'
				})
			} else {
				this.$message({
					message: '不在可配送范围内',
					type: 'error'
				})
			}
		},
		initSearchInput () {
			this.autoInput = new _AMap.Autocomplete({
				input: 'searchInput'
			})
			this.autoInput.on('select', (ev) => {
				this.$message({
					message: `地址定位${ev.poi.location.lng},${ev.poi.location.lat}`
				})
			})
		},
		initDrive () {
			this.drive = new _AMap.Driving({
				policy: _AMap.DrivingPolicy.LEAST_TIME,
				map: this.mapObj
			})
		},
		computedDriving () {
			let startPoint = this.mapMakers[0].getPosition()
			let endPoint = this.mapMakers[this.mapMakers.length - 1].getPosition()
			let startLngLat = [
				startPoint.lng,
				startPoint.lat
			]
			let endLngLat = [
				endPoint.lng,
				endPoint.lat
			]
			let waypoints = this.mapMakers.filter((item, index) => {
				return index !== 0 && index !== this.mapMakers.length - 1
			})
			waypoints = waypoints.map(item => {
				return item.getPosition()
			})
			var opts = {
				waypoints
			}
			this.drive.search(startLngLat, endLngLat, opts, (status, result) => {
				if (status === 'complete') {
					this.$message({
						message: `路线规划成功! 共计${result.routes[0].distance / 1000}公里`
					})
				}
			})
		},
		clearDriving () {
			this.drive.clear()
		}
	}
}
</script>
<style lang="stylus" scoped>
.message {
	font-size:30px
	padding:20px
}
.btn-bar {
	margin-bottom:20px
}
</style>
